module.exports = __webpack_public_path__ + "img/blog-cv-7.59c812ca.webp";